import { motion, AnimatePresence } from "framer-motion";

export default function ResultBox({ result, error }) {
  return (
    <AnimatePresence>
      {result && (
        <motion.div
          key="result"
          initial={{ opacity: 0, scale: 0.7 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.7 }}
          className="result-box"
        >
          {result}
        </motion.div>
      )}
      {error && (
        <motion.div
          key="error"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="error-box"
        >
          {error}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
